import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";

const InvoiceSocialEdit = () => {
  const [whatsapplink, setWhatsapplink] = useState("");
  const [telegramlink, setTelegramlink] = useState("");
  const [instagramlink, setInstagramlink] = useState("");
  const [facebooklink, setFacebooklink] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoiceSocial/${id}`);
      setWhatsapplink(data.whats_app_link);
      setTelegramlink(data.telegram_link);
      setInstagramlink(data.instagram_link);
      setFacebooklink(data.facebook_link);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`invoiceSocial/${id}`, {
      whats_app_link: whatsapplink,
      telegram_link: telegramlink,
      instagram_link: instagramlink,
      facebook_link: facebooklink,
    });
    console.log(data);
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/invoiceSocial"} />;
  }
  return (
    <Wrapper pageTitle={"Edit InvoiceSocial"}>
      <InnerNav
        createLink={"/invoiceSocialCreate"}
        listLink={"/invoiceSocial"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              WhatsApp Link{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="WhatsApp Link"
              value={whatsapplink}
              onChange={(e) => setWhatsapplink(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Telegram Link{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Telegram Link"
              value={telegramlink}
              onChange={(e) => setTelegramlink(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Instagram Link{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Instagram Link"
              value={instagramlink}
              onChange={(e) => setInstagramlink(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Facebook Link{" "}
            </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Facebook Link"
              value={facebooklink}
              onChange={(e) => setFacebooklink(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default InvoiceSocialEdit;
